import React, { useState } from "react";
import toast from "react-hot-toast";
import "./css/LandingPage.css";
import VideoPlayer from "./VideoPlayer";
import ParticleBackground from "./ParticleBackground";

function LandingPage({ onManageAccountClick }) {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const openVideoModal = () => setIsVideoModalOpen(true);
  const closeVideoModal = () => setIsVideoModalOpen(false);

  const handlePodcastClick = () => {
    const audioPath =
      "/Beyond_Spam__The_4-Layer_AI_Shield_Protecting_You_from_Next-Gen.m4a";
    console.log("Attempting to open audio file at:", audioPath);

    // Try to open the audio file in a new tab first
    const audioWindow = window.open(audioPath, "_blank");

    // Alternative approach: create an audio element if the window approach fails
    if (!audioWindow) {
      console.log("Window.open failed, trying audio element approach");
      const audio = new Audio(audioPath);
      audio.onerror = () => {
        toast.error(
          "Audio file could not be loaded. Please check your internet connection or contact support.",
        );
      };
      audio.onloadstart = () => {
        console.log("Audio loading started");
      };
      audio.play().catch((error) => {
        console.error("Audio playback failed:", error);
        toast.error(
          "Audio playback failed. The file might not be available or your browser blocked autoplay.",
        );
      });
    }
  };

  return (
    <div className="landing-page">
      {/* Urgency ticker bar */}
      <div className="urgency-ticker">
        <span className="ticker-icon">⚠️</span>
        <span>
          Americans lost <strong>$195.9 billion</strong> to fraud in 2024 —
          that's <strong>$372,000 every minute</strong>. Seniors are the #1
          target.
        </span>
      </div>

      <main className="landing-main particle-container">
        {/* Particle background effect - Phase 1: Storytelling Proposal */}
        <ParticleBackground
          particleCount={40}
          particleColor="rgba(2, 219, 110, 0.25)"
          particleSize={2.5}
          speed={0.3}
        />

        <div className="landing-content-wrapper">
          <img
            src="/ScamDetectionExpert.png"
            alt="Family protected from online scams by KinShield"
            className="landing-image half-size left-aligned"
          />
          <div className="landing-content">
            <h1>
              Your Mom Just Got a "Bank&nbsp;Alert." It's&nbsp;a&nbsp;Scam.
              Would She&nbsp;Know?
            </h1>
            <h2>
              Last year, a grandmother in Ohio lost $68,000 to a text message
              that looked exactly like her bank. Her family wished she'd had
              practice spotting fakes.
              <br />
              <br />
              <strong>KinShield™ gives your family that practice</strong> —
              realistic scam simulations, instant AI analysis of suspicious
              messages, and real-time alerts — so the next "urgent" text gets
              deleted, not&nbsp;believed.
            </h2>
            <div className="hero-proof-strip">
              <div className="proof-item">
                <span className="proof-number">4.2M+</span>
                <span className="proof-label">
                  Scam texts sent daily in the US
                </span>
              </div>
              <div className="proof-divider"></div>
              <div className="proof-item">
                <span className="proof-number">1 in 3</span>
                <span className="proof-label">Seniors targeted each year</span>
              </div>
              <div className="proof-divider"></div>
              <div className="proof-item">
                <span className="proof-number">&lt; 60 sec</span>
                <span className="proof-label">KinShield AI scam analysis</span>
              </div>
            </div>
            <div className="action-buttons">
              <button className="start-trial" onClick={onManageAccountClick}>
                Protect Your Family Now
              </button>
              <p className="hero-micro-copy hero-micro-copy-mobile">
                Free 30-day trial · Cancel anytime
              </p>
              <button className="watch-demo" onClick={openVideoModal}>
                <span className="play-icon">▶</span> Watch Intro
              </button>
              {/* 
              <button className="overview-podcast" onClick={handlePodcastClick}>
                <span className="audio-icon">🎧</span> Overview Podcast
              </button> 
              */}
            </div>
            <p className="hero-micro-copy hero-micro-copy-desktop">
              Free 30-day trial · Cancel anytime
            </p>
          </div>
        </div>
      </main>
      {isVideoModalOpen && <VideoPlayer onCancel={closeVideoModal} />}
    </div>
  );
}

export default LandingPage;
